import axios from 'axios';
import { BIA } from 'core/models';
import { BiaToValidate } from 'core/models/BIA';

export function getBias() {
    return axios.get<BIA[]>('/bia');
}

export function getContratsBia(souscriptId, contratName) {
    return axios.get(`/bia/${souscriptId}/${contratName}`);
}

export function validateBia(souscriptId, contratName, data: BiaToValidate) {
    return axios.post(`/bia/${souscriptId}/${contratName}`, data);
}

export function exportBias() {
    return axios.get<Blob>(`/export_excel/bias`, {
        responseType: 'blob',
    });
}

export function souscripteursContratBiaEnLigne(idSouscripteur, codeBiaEnLigne) {
    const encodedCodeBiaEnLigne = encodeURIComponent(codeBiaEnLigne); // Encode le codeBiaEnLigne
    return axios.get(`/bia/${idSouscripteur}/${encodedCodeBiaEnLigne}/souscripteursContratBiaEnLigne`);
}
